import { render, staticRenderFns } from "./CommonTest.vue?vue&type=template&id=2029a897&scoped=true"
import script from "./CommonTest.vue?vue&type=script&lang=js"
export * from "./CommonTest.vue?vue&type=script&lang=js"
import style0 from "./CommonTest.vue?vue&type=style&index=0&id=2029a897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029a897",
  null
  
)

export default component.exports